import React from 'react';
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import { menuController } from '@ionic/core/components';
import MenuIcon from 'assets/icons/menu.svg';
import UserIcon from 'assets/icons/user.svg';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'core/store';
import './MenuHeader.scss';
import HealthBanner from 'components/health-banner/HealthBanner';

type MenuHeaderProps = {
  title?: string;
};

const MenuHeader: React.FC<MenuHeaderProps> = ({
  title,
  children,
  ...rest
}) => {
  const { name } = useSelector((state: RootState) => state.user);
  const { currentHome } = useSelector((state: RootState) => state.home);
  // Menu open/close is owned entirely by Ionic's menuController (see
  // SideMenu.tsx) — no Redux round-trip. The previous showSlideOutMenu()
  // dispatch + a SideMenu useEffect watching Redux state was a second
  // source of truth that could race/desync, which was why the hamburger
  // button sometimes didn't open the menu.
  const showMenu = () => {
    menuController.open();
  };

  const history = useHistory();

  return (
    <IonHeader className="ion-no-border hk-menu-header" {...rest}>
      <IonToolbar color="grey">
        <IonButtons slot="start">
          <IonButton onClick={() => showMenu()}>
            <IonIcon color="light" icon={MenuIcon} />
          </IonButton>
        </IonButtons>
        <IonTitle className="hk-menu-header">{title}</IonTitle>
        <IonButtons slot="end">
          {!!name && !!currentHome && (
            <IonButton onClick={() => history.push('/account')}>
              <IonIcon color="light" icon={UserIcon} />
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
      <HealthBanner />
      {children}
    </IonHeader>
  );
};

export default MenuHeader;
